// fork overlay: chatwoot-br 320359f47a (blob:83d35bcc09525914) | OSS baseline: v4.15.1 (blob:e17a6142f727e39d) | Ported: 2026-07-03
// Wholesale replacement of the dashboard route aggregator: adds the fork-owned
// pipeline (conversation kanban) route module. Upstream relative imports are
// rewritten alias-form (D-07) so they resolve through the fork overlay plugin.
import settings from 'dashboard/routes/dashboard/settings/settings.routes';
import conversation from 'dashboard/routes/dashboard/conversation/conversation.routes';
import { routes as searchRoutes } from 'dashboard/modules/search/search.routes';
import { routes as contactRoutes } from 'dashboard/routes/dashboard/contacts/routes';
import { routes as companyRoutes } from 'dashboard/routes/dashboard/companies/routes';
import { routes as notificationRoutes } from 'dashboard/routes/dashboard/notifications/routes';
import { routes as inboxRoutes } from 'dashboard/routes/dashboard/inbox/routes';
import { frontendURL } from 'dashboard/helper/URLHelper';
import helpcenterRoutes from 'dashboard/routes/dashboard/helpcenter/helpcenter.routes';
import campaignsRoutes from 'dashboard/routes/dashboard/campaigns/campaigns.routes';
import pipelineRoutes from 'dashboard/routes/dashboard/pipeline/pipeline.routes';
import { routes as captainRoutes } from 'dashboard/routes/dashboard/captain/captain.routes';
import AppContainer from 'dashboard/routes/dashboard/Dashboard.vue';
import Suspended from 'dashboard/routes/dashboard/suspended/Index.vue';
import NoAccounts from 'dashboard/routes/dashboard/noAccounts/Index.vue';
import OnboardingAccountDetails from 'dashboard/routes/dashboard/onboarding/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...pipelineRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
